import { ReactNode, useCallback } from "react";

import { Drawer, DrawerContent, DrawerOverlay, Box } from "@chakra-ui/react";
import { updateModalData } from "store";
import { useDispatch, useSelector } from "react-redux";

import { MODAL_TYPES } from "@constants/modal";

export interface PageLayoutProps {
  Sidebar: ReactNode;
  MobileSideBar: ReactNode;
  Header: ReactNode;
  children: ReactNode;
  RightSidebar?: ReactNode;
}

const PageLayout = ({
  Sidebar,
  Header,
  children,
  MobileSideBar,
  RightSidebar,
}: PageLayoutProps) => {
  const { modalType } = useSelector((state: any) => state.modal);

  const dispatch = useDispatch();

  const handleClose = useCallback(() => {
    dispatch(
      updateModalData({
        modalType: "",
        isMobileView: false,
        errorMessage: "",
      })
    );
  }, [dispatch]);

  return (
    <Box pt={{ base: 0, xl: "2rem" }} mb={4} bg="backgroundCanvas">
      {Sidebar && Sidebar}
      {MobileSideBar && (
        <Drawer
          isOpen={modalType === MODAL_TYPES.MOBILE_SIDEBAR_MENU_MODAL}
          placement="left"
          onClose={() => handleClose()}
          returnFocusOnClose={false}
          onOverlayClick={handleClose}
        >
          <DrawerOverlay bg="modalOverlay" />
          <DrawerContent bg="backgroundCard">{MobileSideBar}</DrawerContent>
        </Drawer>
      )}
      {Header && Header}
      <Box mt={{ base: 2, xl: 104 }}>{children}</Box>
      {RightSidebar && RightSidebar}
    </Box>
  );
};

export default PageLayout;
